import { FilterFn } from '../interfaces/FilterFn';

export function createBooleanFilterFunction<T>(predicate: (item: T) => boolean): FilterFn<T, boolean> {
  return (item: T, value: boolean) => predicate(item) === value;
}
